function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { RentListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { StringRange } from '../range';
import { isShortDate } from '../../utils/is-short-date';
import { SimpleSearchQueryField } from '../simple-search-query-field';
var parseAvailability = availability => {
  if (!availability || typeof availability !== 'string') {
    return null;
  }
  var date = availability;
  var isTo = availability.indexOf('-') === 0;
  date = isTo ? date.slice(1) : date;
  if (isShortDate(date)) {
    return isTo ? [null, date] : [date, null];
  }
  return null;
};
export class AvailabilityFilter extends SimpleSearchQueryField {
  get validListingTypes() {
    return [...RentListingTypeKeys, 'SHARE_RESIDENTIAL'];
  }
  constructor(searchOptions, value) {
    super(searchOptions, value ? new StringRange(value) : null);
    _defineProperty(this, "urlSlug", AvailabilityFilter.urlSlug);
  }
  getUrlParameterValue() {
    var value = this.internalValue;
    if (!value || value.isEmpty()) {
      return null;
    }
    return value.max && !value.min ? "-".concat(value.max) : "".concat(value.min);
  }
  static fromUrlParameters(searchOptions, q) {
    return new AvailabilityFilter(searchOptions, parseAvailability(q[AvailabilityFilter.urlSlug]));
  }
}
_defineProperty(AvailabilityFilter, "urlSlug", 'availability');